//
import SlSaleInvoiceModel from '@/models/Sale/SlSaleInvoice'

/**
 * This class describes a sl customer.
 * @class SlSaleInvoice (name)
 */
export default class SlSaleInvoice extends SlSaleInvoiceModel {

	/**
	 * Returns a list representation of the object.
	 * @return {Object} List representation of the object.
	 */
	static toList() {
		return this
	}
}